
import { createSlice, current } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { initialState } from "../../../app/initialState";


export const bucketSlice = createSlice({
    name: 'bucketList',
    initialState: initialState.bucketList,
    reducers: {
        setCloseOption: (state, action) => {
            state.closeOption = action.payload
        },
        setStepMenuOpen: (state, action) => {
            state.stepMenuOpen = action.payload;
        },
        setTimeFrameMenuOpen: (state, action) => {
            state.timeFrameMenuOpen = action.payload;
        },
        setCloseOptionsMenuOpen: (state, action) => {
            state.closeOptionsMenuOpen = action.payload;
        },
        setBucketList: (state, action) => {
            state.buckets = action.payload
        },
        setCalendarTodos: (state, action) => {
            state.calendarTodos = action.payload
        },
        setFeelData: (state, action) => {
            state.feelData = action.payload
        },
        updateBucketFeel: (state, action) => {
            const { bucketRowID, date, feelEntry } = action.payload;
            if (!state.feelData[bucketRowID]) {
                state.feelData[bucketRowID] = {};
            }
            state.feelData[bucketRowID][date] = feelEntry;
        },
        setSpreadsheetID: (state, action) => {
            state.spreadsheetID = action.payload
        },
        setTimeFrame: (state, action) => {
            state.timeFrame = action.payload
        },
        setStep: (state, action) => {
            state.step = action.payload
        },
        setCurrentDate: (state, action) => {
            state.currentDate = action.payload
        },
        setCurrentTimeSlot: (state, action) => {
            state.currentTimeSlot = action.payload
        },
        setMinimizeCategories: (state, action) => {
            state.minimizeCategories = action.payload
        },
        setBucketViewIsOn: (state, action) => {
            state.bucketViewIsOn = action.payload;
        },
        setSelectedTodo: (state, action) => {
            state.selectedTodo = action.payload;
        },
        toggleBucketViewIsOn: (state) => {
            state.bucketViewIsOn = !state.bucketViewIsOn;
        }

    }
})


export const { setStepMenuOpen, setTimeFrameMenuOpen, setCloseOptionsMenuOpen, setCloseOption, setMinimizeCategories, setBucketList, setCalendarTodos, setFeelData, updateBucketFeel, setSpreadsheetID, setTimeFrame, setStep, setCurrentDate, setCurrentTimeSlot, setBucketViewIsOn, toggleBucketViewIsOn, setSelectedTodo } = bucketSlice.actions;
export const selectBucketViewIsOn = (state) => state.bucketList.bucketViewIsOn;
export default bucketSlice.reducer;

window.setBucketList = setBucketList;
window.setSpreadsheetID = setSpreadsheetID;
window.setCurrentDate = setCurrentDate;

export const selectSelectedTodo = (state) => state.bucketList.selectedTodo;
export const selectBuckets = (state) => state.bucketList.buckets;
export const selectCalendarTodos = (state) => state.bucketList.calendarTodos;
export const selectFeelData = (state) => state.bucketList.feelData;
export const selectMinimizeCategory = (state) => state.bucketList.minimizeCategories;
export const selectSpreadsheetID = (state) => state.bucketList.spreadsheetID;
export const selectTimeFrame = (state) => state.bucketList.timeFrame;
export const selectCloseOption = (state) => state.bucketList.closeOption;
export const selectStep = (state) => state.bucketList.step;
export const selectCurrentDate = (state) => state.bucketList.currentDate;
export const selectCurrentTimeSlot = (state) => state.bucketList.currentTimeSlot;
export const selectStepMenuOpen = (state) => state.bucketList.stepMenuOpen;
export const selectTimeFrameMenuOpen = (state) => state.bucketList.timeFrameMenuOpen;
export const selectCloseOptionsMenuOpen = (state) => state.bucketList.closeOptionsMenuOpen;
window.selectBuckets = selectBuckets;